var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLandingPlatformBgEffect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 959,
    height: 579,
    viewBox: "0 0 959 579",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.01001 24.0196H6.02002V73.3096L7.01001 72.8996V24.0196Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.43293 16.8878L8.73291 16.1877L17.9323 6.98835L18.6323 7.68838L9.43293 16.8878Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.88 17.0596H15.5698V16.0695H222.88V17.0596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.72 16.5598L217.07 8.90973H180.33L168.02 21.2197L73.3101 21.0697C73.3101 21.0697 67.54 14.5497 67.54 15.5497C67.54 16.5497 224.72 16.5598 224.72 16.5598Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.77 -0.000305176H194.88V0.999695H177.18L166.71 11.4697L166 10.7697L176.77 -0.000305176Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16992 67.7896H5V37.9496H8.16992V67.7896Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.27 8.91968H22.6499V5.99969H93.27V8.91968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.01001 554.45H6.02002V505.16L7.01001 505.57V554.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.43293 561.582L8.73291 562.282L17.9323 571.481L18.6323 570.781L9.43293 561.582Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.88 561.41H15.5698V562.4H266.88V561.41Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.72 561.91L257.07 569.56H180.33L168.02 557.25L73.3101 557.4C73.3101 557.4 67.54 563.92 67.54 562.92C67.54 561.92 264.72 561.91 264.72 561.91Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.26 568.37H264.72V567.38H357.85L358.26 568.37Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.77 578.47H194.88V577.47H177.18L166.71 567L166 567.7L176.77 578.47Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16992 510.68H5V540.52H8.16992V510.68Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.27 569.55H22.6499V572.47H93.27V569.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.26 567.88H289.59V570.12H342.26V567.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M951.13 24.0196H952.12V73.3096L951.13 72.8996V24.0196Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.707 16.8878L949.407 16.1877L940.208 6.98837L939.508 7.68839L948.707 16.8878Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.26 17.0596H942.57V16.0695H735.26V17.0596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.42 16.5598L741.07 8.90973H777.81L790.12 21.2197L884.83 21.0697C884.83 21.0697 890.6 14.5497 890.6 15.5497C890.6 16.5497 733.42 16.5598 733.42 16.5598Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.37 -0.000305176H763.26V0.999695H780.96L791.43 11.4697L792.14 10.7697L781.37 -0.000305176Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M949.97 67.7896H953.14V37.9496H949.97V67.7896Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.87 8.91968H935.49V5.99969H864.87V8.91968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M951.13 554.45H952.12V505.16L951.13 505.57V554.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.707 561.582L949.407 562.282L940.208 571.481L939.508 570.781L948.707 561.582Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.26 561.41H942.57V562.4H691.26V561.41Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.42 561.91L701.07 569.56H777.81L790.12 557.25L884.83 557.4C884.83 557.4 890.6 563.92 890.6 562.92C890.6 561.92 693.42 561.91 693.42 561.91Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.88 568.37H693.42V567.38H600.29L599.88 568.37Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.37 578.47H763.26V577.47H780.96L791.43 567L792.14 567.7L781.37 578.47Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M949.97 510.68H953.14V540.52H949.97V510.68Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.87 569.55H935.49V572.47H864.87V569.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.88 567.88H668.55V570.12H615.88V567.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2935 287.601L12.2935 244.048L12.5759 244.048L12.5759 287.719L12.2935 287.601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7668 271.221L13.7668 244.048L12.4348 244.048L12.4348 271.221L13.7668 271.221Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00805 287.662L9.00806 162.748L5.49666 162.748L3.11489 165.13L3.11489 217.608L5.49666 219.99L5.49665 286.053L5.49665 287.662L5.49665 291.23L9.00805 287.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.728392 218.263L0.728394 165.097L3.78323 162.042L3.9856 162.245L1.0108 165.215L1.0108 218.145L3.89148 221.026L3.89147 291.231L3.60907 291.231L3.60907 221.143L0.728392 218.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3593 288.868L13.6208 287.602L13.6208 286.189L13.908 286.189L13.908 287.719L12.5571 289.07L12.3593 288.868Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99117 162.287L7.99117 162L10.2976 162L10.2976 164.829L10.0105 164.829L10.0105 162.287L7.99117 162.287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.34277 287.601L2.34277 244.048L2.05565 244.048L2.05565 287.719L2.34277 287.601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.20166 271.221L2.20166 244.048L0.869545 244.048L0.869544 271.221L2.20166 271.221Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.62839 287.662L5.62839 162.748L9.13514 162.748L11.5168 165.13L11.5168 217.608L9.13514 219.99L9.13513 286.053L9.13513 287.662L9.13513 291.23L5.62839 287.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.908 218.263L13.908 165.097L10.8531 162.042L10.6507 162.245L13.6208 165.215L13.6208 218.145L10.7402 221.026L10.7402 291.231L11.0273 291.231L11.0273 221.143L13.908 218.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.27686 288.868L1.0107 287.602L1.0107 286.189L0.728294 286.189L0.728294 287.719L2.07449 289.07L2.27686 288.868Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.64038 162.287L6.64038 162L4.33865 162L4.33865 164.829L4.62112 164.829L4.62112 162.287L6.64038 162.287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2935 289.814L12.2935 333.368L12.5759 333.368L12.5759 289.696L12.2935 289.814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4329 306.195L12.4329 333.368L13.7649 333.368L13.7649 306.195L12.4329 306.195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00781 289.757L9.00781 414.671L5.49641 414.671L3.11464 412.289L3.11465 359.807L5.49641 357.425L5.49641 291.362L5.49641 289.757L5.49641 286.189L9.00781 289.757Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.728391 359.157L0.728389 412.322L3.78322 415.377L3.98559 415.175L1.0108 412.205L1.0108 359.275L3.89148 356.394L3.89148 286.189L3.60907 286.189L3.60907 356.272L0.728391 359.157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3593 288.547L13.6208 289.813L13.6208 291.23L13.908 291.23L13.908 289.696L12.5571 288.349L12.3593 288.547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99117 415.132L7.99117 415.419L10.2976 415.419L10.2976 412.591L10.0105 412.591L10.0105 415.132L7.99117 415.132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.34277 289.814L2.34277 333.368L2.05565 333.368L2.05565 289.696L2.34277 289.814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.867921 306.195L0.86792 333.368L2.20004 333.368L2.20004 306.195L0.867921 306.195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.62839 289.757L5.62839 414.671L9.13513 414.671L11.5168 412.289L11.5168 359.807L9.13513 357.425L9.13514 291.362L9.13514 289.757L9.13514 286.189L5.62839 289.757Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.908 359.157L13.908 412.322L10.8531 415.377L10.6507 415.175L13.6208 412.205L13.6208 359.275L10.7402 356.394L10.7402 286.189L11.0273 286.189L11.0273 356.272L13.908 359.157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.27686 288.547L1.0107 289.813L1.0107 291.23L0.728294 291.23L0.728294 289.696L2.07449 288.349L2.27686 288.547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.64038 415.132L6.64038 415.419L4.33865 415.419L4.33865 412.591L4.62112 412.591L4.62112 415.132L6.64038 415.132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.565 287.601L956.565 244.048L956.847 244.048L956.847 287.719L956.565 287.601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.038 271.221L958.038 244.048L956.706 244.048L956.706 271.221L958.038 271.221Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953.28 287.662L953.28 162.748L949.768 162.748L947.386 165.13L947.386 217.608L949.768 219.99L949.768 286.053L949.768 287.662L949.768 291.23L953.28 287.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945 218.263L945 165.097L948.055 162.042L948.257 162.245L945.283 165.215L945.283 218.145L948.163 221.026L948.163 291.231L947.881 291.231L947.881 221.143L945 218.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.631 288.868L957.893 287.602L957.893 286.189L958.18 286.189L958.18 287.719L956.829 289.07L956.631 288.868Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M952.263 162.287L952.263 162L954.569 162L954.569 164.829L954.282 164.829L954.282 162.287L952.263 162.287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946.615 287.601L946.615 244.048L946.327 244.048L946.327 287.719L946.615 287.601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946.473 271.221L946.473 244.048L945.141 244.048L945.141 271.221L946.473 271.221Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M949.9 287.662L949.9 162.748L953.407 162.748L955.788 165.13L955.788 217.608L953.407 219.99L953.407 286.053L953.407 287.662L953.407 291.23L949.9 287.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.18 218.263L958.18 165.097L955.125 162.042L954.922 162.245L957.893 165.215L957.893 218.145L955.012 221.026L955.012 291.231L955.299 291.231L955.299 221.143L958.18 218.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946.549 288.868L945.282 287.602L945.282 286.189L945 286.189L945 287.719L946.346 289.07L946.549 288.868Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.912 162.287L950.912 162L948.61 162L948.61 164.829L948.893 164.829L948.893 162.287L950.912 162.287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.565 289.814L956.565 333.368L956.847 333.368L956.847 289.696L956.565 289.814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.705 306.195L956.705 333.368L958.037 333.368L958.037 306.195L956.705 306.195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953.28 289.757L953.28 414.671L949.768 414.671L947.387 412.289L947.387 359.807L949.768 357.425L949.768 291.362L949.768 289.757L949.768 286.189L953.28 289.757Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945 359.157L945 412.322L948.055 415.377L948.257 415.175L945.283 412.205L945.283 359.275L948.163 356.394L948.163 286.189L947.881 286.189L947.881 356.272L945 359.157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.631 288.547L957.893 289.813L957.893 291.23L958.18 291.23L958.18 289.696L956.829 288.349L956.631 288.547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M952.263 415.132L952.263 415.419L954.569 415.419L954.569 412.591L954.282 412.591L954.282 415.132L952.263 415.132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946.615 289.814L946.615 333.368L946.327 333.368L946.327 289.696L946.615 289.814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945.14 306.195L945.14 333.368L946.472 333.368L946.472 306.195L945.14 306.195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M949.9 289.757L949.9 414.671L953.407 414.671L955.788 412.289L955.788 359.807L953.407 357.425L953.407 291.362L953.407 289.757L953.407 286.189L949.9 289.757Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.18 359.157L958.18 412.322L955.125 415.377L954.922 415.175L957.893 412.205L957.893 359.275L955.012 356.394L955.012 286.189L955.299 286.189L955.299 356.272L958.18 359.157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946.549 288.547L945.282 289.813L945.282 291.23L945 291.23L945 289.696L946.346 288.349L946.549 288.547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.912 415.132L950.912 415.419L948.61 415.419L948.61 412.591L948.893 412.591L948.893 415.132L950.912 415.132Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingPlatformBgEffect);
export default __webpack_public_path__ + "static/media/landingPlatformBGEffect.32099aaf6f3d2fc65fca7f87368b8058.svg";
export { ForwardRef as ReactComponent };